import React from 'react';
import { H6, P } from 'components/reusable-css';
import CustomButton from 'components/common/custom-button';
import Select from 'components/select';
import Checkbox from 'components/common/radio-button';
import Input from 'components/input';
import * as Styles from '../style';
import { ErrorMessage, Form } from 'formik';
import { ALL, INPUT, OBJECT_DROPDOWN, PORT_DROPDOWN } from '../utils';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import Toggle from 'components/common/toggle';
import { ipRegex } from 'constants/regex';

const RuleForm = ({ edit, firewallServies, formik, uniqueProtocol, objectArr = [] }) => {
  const { values, handleBlur, handleChange, setFieldValue, errors, touched } = formik;
  const { t } = useTranslation();

  const handlePortArr = (values) => {
    let isArray = [];
    if (values.protocol != 'all') {
      isArray = firewallServies?.network_services
        ?.filter((data) => data.protocol === values.protocol)
        ?.sort((a, b) => Number(b.priority) - Number(a.priority)); // rearrange by priority
    } else {
      isArray = firewallServies?.network_services?.sort((a, b) => Number(b.priority) - Number(a.priority)); // rearrange by priority
    }

    const portData = isArray?.map((data) => {
      return { text: `${data.id} (${data.service})`, value: data.id };
    });

    return portData;
  };

  const handleFirstPort = (protocol) => {
    let isArray = [];
    if (protocol != 'all') {
      isArray = firewallServies?.network_services
        ?.filter((data) => data.protocol === protocol)
        ?.sort((a, b) => Number(b.priority) - Number(a.priority)); // rearrange by priority
    } else {
      isArray = firewallServies?.network_services?.sort((a, b) => Number(b.priority) - Number(a.priority)); // rearrange by priority
    }
    return isArray[0].id;
  };

  const handleSrcOption = (value) => {
    if (value != values.src_checkbox) {
      setFieldValue('src_checkbox', value);
      setFieldValue('src_ip_input', '');
      setFieldValue('src_object_dropdown', '');
    }
  };

  const handleDstIpOption = (value) => {
    if (value != values.dst_ip_checkbox) {
      setFieldValue('dst_ip_checkbox', value);
      setFieldValue('dst_ip_input', '');
      setFieldValue('dst_ip_object_dropdown', '');
    }
  };

  const handleDstServiceOption = (value) => {
    if (value != values.dst_service_checkbox) {
      setFieldValue('dst_service_checkbox', value);
      setFieldValue('dst_service_input', '');
      if (value == PORT_DROPDOWN) {
        setFieldValue('dst_service_dropdown', handleFirstPort(values.protocol) || '');
      } else {
        setFieldValue('dst_service_dropdown', '');
      }
      setFieldValue('dst_service_object_dropdown', '');
    }
  };

  return (
    <Form style={{ paddingRight: '10px', paddingTop: '10px' }}>
      <Styles.SectionFlex>
        <H6>{t('vs/firewall.string28')}</H6>
        <Styles.Width50>
          <Styles.FlexContainerAction>
            <Toggle
              handleChange={(e) => setFieldValue('action', e.target.checked ? 'allow' : 'deny')}
              value={'active'}
              checked={values.action == 'allow'}
              color={'#59c025'}
            />
            <H6>
              <Trans
                i18nKey={'vs/firewall.string58'}
                components={{
                  red: <span style={{ color: 'red' }} />,
                  green: <span style={{ color: '#59c025' }} />,
                }}
              />
            </H6>
          </Styles.FlexContainerAction>
        </Styles.Width50>
      </Styles.SectionFlex>

      <Styles.SectionFlex>
        <H6>{t('vs/firewall.string29')}</H6>
        <Styles.Width50>
          <Select
            options={uniqueProtocol}
            styling={{ width: '100%', marginTop: '-8px' }}
            name={'protocol'}
            value={values['protocol']}
            onChange={(e) => {
              setFieldValue('protocol', e.target.value);
              setFieldValue('dst_service_dropdown', handleFirstPort(e.target.value));
            }}
            onBlur={handleBlur}
            error={errors['protocol']}
            touched={touched['protocol']}
          />
        </Styles.Width50>
      </Styles.SectionFlex>

      <Styles.GreyBorder />

      {/* src */}
      <Styles.Section>
        <H6>{t('vs/firewall.string30')}</H6>
        <Styles.SourceContainer>
          <Styles.RadioContainer>
            <Styles.RadioCard onClick={() => handleSrcOption(ALL)}>
              <Checkbox
                checkbox={values.src_checkbox}
                setCheckedValue={(value) => handleSrcOption(value)}
                data={{ id: ALL }}
                onClick={() => handleSrcOption(ALL)}
              />
              <P>{t('vs/firewall.string57')}</P>
            </Styles.RadioCard>
          </Styles.RadioContainer>
          <Styles.RadioContainer>
            <Styles.RadioCard onClick={() => handleSrcOption(INPUT)}>
              <Checkbox
                checkbox={values.src_checkbox}
                setCheckedValue={(value) => handleSrcOption(value)}
                data={{ id: INPUT }}
                onClick={() => handleSrcOption(INPUT)}
              />
              <P>{t('vs/firewall.string32')}</P>
            </Styles.RadioCard>
            <Styles.Width50 onClick={() => setFieldValue('src_checkbox', INPUT)}>
              <Input
                type="text"
                styling={{ fontSize: '16px', marginTop: '-1.8rem', marginBottom: 0 }}
                placeholder={t('vs/firewall.string33')}
                name={'src_ip_input'}
                value={values['src_ip_input']}
                onChange={handleChange}
                onBlur={(e) => {
                  let val = e.target.value;
                  // Only append /32 if it's a valid full IP and no subnet is present
                  if (ipRegex.test(val) && !val.includes('/')) {
                    val = `${val}/32`;
                    setFieldValue('src_ip_input', val);
                  }
                  handleBlur(e);
                }}
                error={errors['src_ip_input']}
                touched={touched['src_ip_input']}
                dataTooltip={t('vs/firewall.string82')}
                tooltipStyles={{ leftPosition: '0%' }}
              />
              <P className="para">{t('vs/firewall.string34')}</P>
            </Styles.Width50>
          </Styles.RadioContainer>
          <Styles.RadioContainer onClick={() => setFieldValue('src_checkbox', OBJECT_DROPDOWN)}>
            <Styles.RadioCard onClick={() => handleSrcOption(OBJECT_DROPDOWN)}>
              <Checkbox
                checkbox={values.src_checkbox}
                setCheckedValue={(value) => handleSrcOption(value)}
                data={{ id: OBJECT_DROPDOWN }}
                onClick={() => handleSrcOption(OBJECT_DROPDOWN)}
              />
              <P>{t(`vs/firewall.string72`)}</P>
            </Styles.RadioCard>
            <Styles.Width50>
              {errors['src_object_dropdown'] && touched['src_object_dropdown'] && (
                <div
                  style={{
                    marginTop: '-1.8rem',
                    whiteSpace: 'nowrap',
                    position: 'relative',
                    zIndex: 1000,
                  }}
                >
                  <ErrorMessage
                    name={'src_object_dropdown'}
                    render={(msg) => (
                      <span className="error_messageSty">
                        <Trans i18nKey={msg} />
                      </span>
                    )}
                  />
                </div>
              )}
              <Select
                options={[
                  { text: 'vs/firewall.string78', value: '' },
                  ...objectArr?.filter((obj) => obj.type === 'ipv4'),
                ]}
                styling={{ width: '100%', marginTop: '0' }}
                name={'src_object_dropdown'}
                value={values['src_object_dropdown']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['src_object_dropdown']}
                touched={touched['src_object_dropdown']}
              />
            </Styles.Width50>
          </Styles.RadioContainer>
        </Styles.SourceContainer>
      </Styles.Section>

      {/* dst ip */}
      <Styles.Section>
        <H6>{t('vs/firewall.string35')}</H6>
        <Styles.SourceContainer>
          <Styles.RadioContainer>
            <Styles.RadioCard onClick={() => handleDstIpOption(ALL)}>
              <Checkbox
                checkbox={values.dst_ip_checkbox}
                setCheckedValue={(value) => handleDstIpOption(value)}
                data={{ id: ALL }}
                onClick={() => handleDstIpOption(ALL)}
              />
              <P>{t('vs/firewall.string31')}</P>
            </Styles.RadioCard>
          </Styles.RadioContainer>
          <Styles.RadioContainer onClick={() => setFieldValue('dst_ip_checkbox', INPUT)}>
            <Styles.RadioCard onClick={() => handleDstIpOption(INPUT)}>
              <Checkbox
                checkbox={values.dst_ip_checkbox}
                setCheckedValue={(value) => handleDstIpOption(value)}
                data={{ id: INPUT }}
                onClick={() => handleDstIpOption(INPUT)}
              />
              <P>{t('vs/firewall.string32')}</P>
            </Styles.RadioCard>
            <Styles.Width50>
              <Input
                type="text"
                styling={{ fontSize: '16px', marginTop: '-1.8rem', marginBottom: 0 }}
                placeholder={t('vs/firewall.string33')}
                name={'dst_ip_input'}
                value={values['dst_ip_input']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['dst_ip_input']}
                touched={touched['dst_ip_input']}
                dataTooltip={t('vs/firewall.string82')}
                tooltipStyles={{ leftPosition: '0%' }}
              />
              <P className="para">{t('vs/firewall.string36')}</P>
            </Styles.Width50>
          </Styles.RadioContainer>
          <Styles.RadioContainer onClick={() => setFieldValue('dst_ip_checkbox', OBJECT_DROPDOWN)}>
            <Styles.RadioCard onClick={() => handleDstIpOption(OBJECT_DROPDOWN)}>
              <Checkbox
                checkbox={values.dst_ip_checkbox}
                setCheckedValue={(value) => handleDstIpOption(value)}
                data={{ id: OBJECT_DROPDOWN }}
                onClick={() => handleDstIpOption(OBJECT_DROPDOWN)}
              />
              <P>{t(`vs/firewall.string73`)}</P>
            </Styles.RadioCard>
            <Styles.Width50>
              {errors['dst_ip_object_dropdown'] && touched['dst_ip_object_dropdown'] && (
                <div
                  style={{
                    marginTop: '-1.8rem',
                    whiteSpace: 'nowrap',
                    position: 'relative',
                    zIndex: 1000,
                  }}
                >
                  <ErrorMessage
                    name={'dst_ip_object_dropdown'}
                    render={(msg) => (
                      <span className="error_messageSty">
                        <Trans i18nKey={msg} />
                      </span>
                    )}
                  />
                </div>
              )}
              <Select
                options={[
                  { text: 'vs/firewall.string78', value: '' },
                  ...objectArr?.filter((obj) => obj.type === 'ipv4' || obj.type === 'ipv6'),
                ]}
                styling={{ width: '100%', marginTop: '0' }}
                name={'dst_ip_object_dropdown'}
                value={values['dst_ip_object_dropdown']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['dst_ip_object_dropdown']}
                touched={touched['dst_ip_object_dropdown']}
              />
            </Styles.Width50>
          </Styles.RadioContainer>
        </Styles.SourceContainer>
      </Styles.Section>

      {/* dst service */}
      <Styles.Section>
        <H6>{t('vs/firewall.string75')}</H6>
        <Styles.SourceContainer>
          <Styles.RadioContainer>
            <Styles.RadioCard onClick={() => handleDstServiceOption(ALL)}>
              <Checkbox
                checkbox={values.dst_service_checkbox}
                setCheckedValue={(value) => handleDstServiceOption(value)}
                data={{ id: ALL }}
                onClick={() => handleDstServiceOption(ALL)}
              />
              <P>{t('vs/firewall.string85')}</P>
            </Styles.RadioCard>
          </Styles.RadioContainer>
          <Styles.RadioContainer
            style={{ marginTop: '2em' }}
            onClick={() => setFieldValue('dst_service_checkbox', PORT_DROPDOWN)}
          >
            <Styles.RadioCard onClick={() => handleDstServiceOption(PORT_DROPDOWN)}>
              <Checkbox
                checkbox={values.dst_service_checkbox}
                setCheckedValue={(value) => handleDstServiceOption(value)}
                data={{ id: PORT_DROPDOWN }}
                onClick={() => handleDstServiceOption(PORT_DROPDOWN)}
              />
              <P>{t('vs/firewall.string37')}</P>
            </Styles.RadioCard>
            <Styles.Width50>
              <Select
                options={handlePortArr(values)}
                styling={{ width: '100%', marginTop: '0' }}
                name={'dst_service_dropdown'}
                value={values['dst_service_dropdown']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['dst_service_dropdown']}
                touched={touched['dst_service_dropdown']}
              />
            </Styles.Width50>
          </Styles.RadioContainer>
          <Styles.RadioContainer onClick={() => setFieldValue('dst_service_checkbox', INPUT)}>
            <Styles.RadioCard onClick={() => handleDstServiceOption(INPUT)}>
              <Checkbox
                checkbox={values.dst_service_checkbox}
                setCheckedValue={(value) => handleDstServiceOption(value)}
                data={{ id: INPUT }}
                onClick={() => handleDstServiceOption(INPUT)}
              />
              <P>{t('vs/firewall.string38')}</P>
            </Styles.RadioCard>
            <Styles.Width50>
              <Input
                type="text"
                styling={{ fontSize: '16px', marginTop: '-1.8rem', marginBottom: 0 }}
                placeholder={'Port'}
                name="dst_service_input"
                value={values['dst_service_input']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['dst_service_input']}
                touched={touched['dst_service_input']}
              />
            </Styles.Width50>
          </Styles.RadioContainer>
          <Styles.RadioContainer onClick={() => setFieldValue('dst_service_checkbox', OBJECT_DROPDOWN)}>
            <Styles.RadioCard onClick={() => handleDstServiceOption(OBJECT_DROPDOWN)}>
              <Checkbox
                checkbox={values.dst_service_checkbox}
                setCheckedValue={(value) => handleDstServiceOption(value)}
                data={{ id: OBJECT_DROPDOWN }}
                onClick={() => handleDstServiceOption(OBJECT_DROPDOWN)}
              />
              <P>{t(`vs/firewall.string74`)}</P>
            </Styles.RadioCard>
            <Styles.Width50>
              {errors['dst_service_object_dropdown'] && touched['dst_service_object_dropdown'] && (
                <div
                  style={{
                    marginTop: '-1.8rem',
                    whiteSpace: 'nowrap',
                    position: 'relative',
                    zIndex: 1000,
                  }}
                >
                  <ErrorMessage
                    name={'dst_service_object_dropdown'}
                    render={(msg) => (
                      <span className="error_messageSty">
                        <Trans i18nKey={msg} />
                      </span>
                    )}
                  />
                </div>
              )}
              <Select
                options={[
                  { text: 'vs/firewall.string78', value: '' },
                  ...objectArr?.filter((obj) => obj.type === 'port'),
                ]}
                styling={{ width: '100%', marginTop: '0' }}
                name={'dst_service_object_dropdown'}
                value={values['dst_service_object_dropdown']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['dst_service_object_dropdown']}
                touched={touched['dst_service_object_dropdown']}
              />
            </Styles.Width50>
          </Styles.RadioContainer>
        </Styles.SourceContainer>
      </Styles.Section>
      <Styles.SectionButton>
        <CustomButton title={edit ? 'vs/firewall.string56' : 'vs/firewall.string39'} type="submit" />
      </Styles.SectionButton>
    </Form>
  );
};

export default RuleForm;
